var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalDetailsSpeciaux",
            size: "xxl",
            title:
              "Documents spéciaux pour " + _vm.currentSpeciaux.nomFournisseur,
            "ok-only": "",
            "modal-class": "height-responsive",
            "body-class": "height-responsive-body height-responsive-0b",
            "ok-title": "Fermer",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-6",
                    staticStyle: { "text-align": "right" }
                  },
                  [
                    _vm.currentSpeciaux.urlLogo !== ""
                      ? _c("div", [
                          _c("img", {
                            staticClass: "speciaux-logo",
                            attrs: { src: _vm.currentSpeciaux.urlLogo }
                          })
                        ])
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-6",
                    staticStyle: { "text-align": "center" }
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "left" } }, [
                      _c("br"),
                      _c("div", { staticClass: "bold600" }, [
                        _vm._v(_vm._s(_vm.currentSpeciaux.nomFournisseur))
                      ]),
                      _c("div", { staticClass: "text-sm" }, [
                        _vm._v(_vm._s(_vm.currentSpeciaux.contact))
                      ]),
                      _c("div", { staticClass: "text-sm" }, [
                        _vm._v(_vm._s(_vm.currentSpeciaux.adresse))
                      ])
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 mt-3",
                    staticStyle: { "text-align": "center" }
                  },
                  [
                    _vm.currentSpeciaux.urlBanniere
                      ? _c("div", [
                          _c("img", {
                            staticClass: "speciaux-banniere",
                            attrs: { src: _vm.currentSpeciaux.urlBanniere }
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _c("br"),
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.currentSpeciaux.listeParCategorie, function(spe) {
                  return _c(
                    "div",
                    {
                      key: spe.idFournisseur,
                      staticClass: "col-xl-4 col-lg-4 col-md-6 col-sm-12"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { cursor: "pointer", heigth: "160px" }
                        },
                        [
                          _c(
                            "div",
                            { class: "card-header background-primary" },
                            [_vm._v(" " + _vm._s(spe.nomCategorie) + " ")]
                          ),
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(spe.listeSpeciaux, function(doc) {
                                return _c(
                                  "div",
                                  {
                                    key: doc.speciauxId,
                                    staticClass: "col-12",
                                    on: {
                                      click: function($event) {
                                        return _vm.incrementCompteurSpeciaux(
                                          doc.speciauxId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: doc.video
                                            ? doc.lienVideo
                                            : doc.cheminWeb,
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "card" }, [
                                          _c(
                                            "div",
                                            { staticClass: "card-body" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    "bold600 " +
                                                    (doc.estNouveau
                                                      ? "text-success"
                                                      : "text-black")
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        doc.estNouveau
                                                          ? "(nouveau)  "
                                                          : ""
                                                      ) +
                                                      _vm._s(doc.nom) +
                                                      "   "
                                                  ),
                                                  _c("i", {
                                                    staticClass: "far fa-lg",
                                                    class: doc.video
                                                      ? "fa-file-video"
                                                      : "fa-file-pdf"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ],
        2
      ),
      _c("BarreFiltres", {
        ref: "barreFiltres",
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _c("div", { staticClass: "card height-responsive" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._v(
            "Cliquez sur un fournisseur pour accéder aux documents disponibles"
          )
        ]),
        _c(
          "div",
          {
            staticClass: "card-body height-responsive-body height-responsive-1b"
          },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.speciaux, function(spe) {
                  return _c(
                    "div",
                    {
                      key: spe.idFournisseur,
                      staticClass: "col-xl-3 col-lg-4 col-md-6 col-sm-12"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                          staticStyle: { cursor: "pointer", heigth: "160px" },
                          on: {
                            click: function($event) {
                              return _vm.drawSpeciaux(spe)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              class: [
                                {
                                  "bg-success": _vm.nombreFichiersNouveaux(spe)
                                }
                              ]
                            },
                            [_vm._v(" " + _vm._s(spe.nomFournisseur) + " ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "card-body container-fluid mh-120" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  staticStyle: { height: "100px" }
                                },
                                [
                                  _c("div", { staticClass: "col-8" }, [
                                    _c("span", { staticClass: "bold600" }, [
                                      _vm._v(_vm._s(_vm.nombreFichiers(spe)))
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "bold600 text-success" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.nombreFichiersNouveaux(spe)
                                          )
                                        )
                                      ]
                                    ),
                                    _c("p", { staticClass: "text-sm" }, [
                                      _vm._v(_vm._s(spe.listeCategorie))
                                    ]),
                                    _c("p", { staticClass: "text-sm" }, [
                                      _vm._v(_vm._s(spe.listeFamille))
                                    ])
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-4 d-flex flex-wrap align-items-center"
                                    },
                                    [
                                      spe.urlLogo !== ""
                                        ? _c("div", [
                                            _c("img", {
                                              staticClass:
                                                "speciaux-liste-logo",
                                              attrs: { src: spe.urlLogo }
                                            })
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }